import type { ComponentImport } from "../../shared/types";
import { DocumentSearchType } from "../../shared/apiClient/data-contracts";

// eslint-disable-next-line @typescript-eslint/no-misused-promises
document.addEventListener("DOMContentLoaded", initDocumentSearch);

async function initDocumentSearch() {
    const elements = document.getElementsByClassName("document-search-app");
    await import("../../shared/theming.css");

    for (const element of elements) {
        const { createApp } = await import("vue");
        // @ts-ignore
        const { default: App } = (await import("./features/searchPage/SearchPage.vue")) as ComponentImport;
        const { default: i18n } = await import("../search/plugins/i18n");
        const { createPinia } = await import("pinia");
        const { useDocumentSearchStore } = await import("./stores/search");
        const { getQueryParam } = await import("../../shared/urlPropUtilities");

        // Import Filters
        const categoryIds =
            element
                .getAttribute("data-default-filter-values")
                ?.split(",")
                .map((id) => id.trim())
                .filter((id) => id.length > 0) ?? ([] as string[]);
        const pageDefaultFilterName = element.getAttribute("data-default-filter-name") ?? "";
        const pageIgnoreFacetFilterCategoryNames =
            element.getAttribute("data-ignore-filter-names")?.replace(" ", "").split(",") ?? ([] as string[]);
        const onlyBookmarked = element.getAttribute("data-only-bookmarked")?.toLowerCase() === "true";
        const searchType = Number(element.getAttribute("data-search-type")) as DocumentSearchType;
        const app = createApp(App);

        // Global Usings
        app.use(i18n, window.i18n).use(createPinia());

        const searchStore = useDocumentSearchStore();

        // restore search term from URL but only if the hash of the url matches the id of the parent container
        // this is neccessary to support multiple search apps on the same page
        if (element.parentElement?.id === window.location.hash.replace("#", "")) {
            const searchTerm = getQueryParam(window.location.search, "q") ?? "";
            searchStore.setSearchTerm(searchTerm);
        }

        searchStore.anchor = element.parentElement?.id ?? "";
        searchStore.categoryIds = categoryIds;
        searchStore.pageDefaultFilterName = pageDefaultFilterName;
        searchStore.searchRequest.searchType = searchType;
        searchStore.searchRequest.searchLanguage = document.documentElement.lang;
        searchStore.ndaUrl = document.documentElement.getAttribute("data-nda-url") ?? "";
        searchStore.searchRequest.onlyBookmarked = onlyBookmarked;
        searchStore.searchRequest.resultsPerPage = searchType === DocumentSearchType.Ppl ? 25 : 8;
        searchStore.ignoreFacetFilterCategoryNames = pageIgnoreFacetFilterCategoryNames;

        app.mount(element);
        await searchStore.search(true);

        // if the parent container id equals the hash, scroll the parent container into view
        if (element.parentElement?.id === window.location.hash.replace("#", "")) {
            setTimeout(() => {
                element.parentElement?.scrollIntoView({ behavior: "smooth" });
            }, 200);
        }
    }
}
